import { _, GridOptions } from "ag-grid-community";

import AjaxDataSource from "./AjaxDataSource";

export default function initializeTable<TModel>(
    options: GridOptions,
    dataSource: AjaxDataSource<TModel>,
    eventName?: string,
    component?: Vue,
    autoResizeColumns?: boolean
) {
    if (component && eventName) {
        component.$root.$on(eventName, () => {
            if (!options.api) {
                return;
            }

            // Refreshes the grid (ex. when something gets deleted)
            options.api.setDatasource(dataSource);
        });
    }

    if (options.api) {
        options.api.setDatasource(dataSource);
        options.api.sizeColumnsToFit();
    }

    if (autoResizeColumns) {
        // Auto-resize columns using ag-grid's debounce utility
        // https://www.geeksforgeeks.org/debouncing-in-javascript/#:~:text=Debouncing%20in%20JavaScript%20is%20a,is%20a%20single%20threaded%20language.
        window.addEventListener("resize", () =>
            _.debounce(() => {
                if (options.api) {
                    options.api.sizeColumnsToFit(); // Re-size columns to fit.
                }
            }, 1000)()
        );
    }
}
